import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "upload-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_sensitive_words = _resolveComponent("sensitive-words");
  const _component_upload_copyright = _resolveComponent("upload-copyright");
  const _component_UploadFilled = _resolveComponent("UploadFilled");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "文件上传",
    width: "30%",
    "model-value": $props.visible,
    onClose: $setup.close
  }, {
    default: _withCtx(() => [_createVNode(_component_el_upload, {
      ref: "upload",
      multiple: "",
      "http-request": $setup.fileUpload,
      "on-remove": $setup.handleRemove,
      "on-success": $setup.handleSuccess,
      "file-list": _ctx.fileList,
      "auto-upload": true,
      "before-upload": $setup.beforeUpload
    }, {
      trigger: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Plus)]),
          _: 1
        }), _cache[2] || (_cache[2] = _createTextVNode(" 选取 素材文件 ", -1))]),
        _: 1
      })]),
      _: 1
    }, 8, ["http-request", "on-remove", "on-success", "file-list", "before-upload"]), _createVNode(_component_sensitive_words, {
      "sens-words-list": _ctx.sensWordsList
    }, null, 8, ["sens-words-list"]), _createVNode(_component_upload_copyright, {
      ref: "copyrightRef",
      copyrightId: _ctx.copyrightId,
      "onUpdate:copyrightId": _cache[0] || (_cache[0] = $event => _ctx.copyrightId = $event),
      uploading: _ctx.subUploading,
      "onUpdate:uploading": _cache[1] || (_cache[1] = $event => _ctx.subUploading = $event)
    }, null, 8, ["copyrightId", "uploading"]), _createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "success",
      onClick: $setup.submitUpload
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_UploadFilled)]),
        _: 1
      }), _cache[3] || (_cache[3] = _createTextVNode(" 上传 ", -1))]),
      _: 1
    }, 8, ["onClick"])), [[_directive_loading, _ctx.uploading && _ctx.subUploading > -1]])])]),
    _: 1
  }, 8, ["model-value", "onClose"]);
}